import React from 'react';
import './styles.css';

export const NotaExplicativa = ({
  percentualRetirada,
  regimeTributacaoDefinitivo,
  aliquotaRegressiva,
  conta,
}) => {
  return (
    <div>
      {!regimeTributacaoDefinitivo && (
        <>
          <p className="content-description">
            {percentualRetirada < 100
              ? `A retirada nesta conta está limitada a ${percentualRetirada}%`
              : 'A retirada nesta conta não possui limite'}{' '}
            e haverá cobrança de imposto de renda sobre o valor resgatado.
          </p>
          <p className="content-description">
            Se optar pelo <b>Regime Progressivo</b>, a alíquota pode chegar a
            até 27,5%, com uma tributação inicial de 15% no momento do
            pagamento. O restante será definido na declaração de ajuste anual do
            Imposto de Renda.
          </p>
          <p className="content-description">
            No caso do <b>Regime Regressivo</b>, a alíquota {aliquotaRegressiva}
            % foi calculada considerando todo saldo de conta {conta}. A alíquota
            será recalculada e definida no momento do pagamento em função do
            percentual e da conta escolhida para o resgate parcial.
          </p>
          <p className="content-description">
            A opção pelo Regime de Tributação é <b>IRRETRATÁVEL</b> e será
            aplicada também no seu benefício de aposentadoria futuro.
          </p>
        </>
      )}

      {regimeTributacaoDefinitivo === 'REGRESSIVO' && (
        <>
          <p className="content-description">
            {percentualRetirada < 100
              ? `A retirada nesta conta está limitada a ${percentualRetirada}%`
              : 'A retirada nesta conta não possui limite'}{' '}
            e haverá cobrança de imposto de renda sobre o valor resgatado.
          </p>
          <p className="content-description">
            <b>Regime Regressivo:</b> A alíquota {aliquotaRegressiva}% foi
            calculada considerando todo saldo de conta {conta}. A alíquota será
            recalculada e definida no momento do pagamento em função do
            percentual e da conta escolhida para o resgate parcial.
          </p>
          <p className="content-description">
            A opção pelo Regime de Tributação é <b>IRRETRATÁVEL</b> e será
            aplicada também no seu benefício de aposentadoria futuro.
          </p>
        </>
      )}

      {regimeTributacaoDefinitivo === 'PROGRESSIVO' && (
        <>
          <p className="content-description">
            {percentualRetirada < 100
              ? `A retirada nesta conta está limitada a ${percentualRetirada}%`
              : 'A retirada nesta conta não possui limite'}{' '}
            e haverá cobrança de imposto de renda sobre o valor resgatado.
          </p>
          <p className="content-description">
            <b>Regime Progressivo:</b> A alíquota pode chegar a até 27,5%, com
            uma tributação inicial de 15% no momento do pagamento. O restante
            será definido na declaração de ajuste anual do Imposto de Renda.
          </p>
          <p className="content-description">
            A opção pelo Regime de Tributação é <b>IRRETRATÁVEL</b> e será
            aplicada também no seu benefício de aposentadoria futuro.
          </p>
        </>
      )}
    </div>
  );
};
